import * as _ from "lodash";
import React, { useState } from "react";
import * as Constants from "../../../Constants";
import {
    fileToDocumentLinkUpload,
    linkToDocumentLink,
} from "../../../Helpers/links";
import * as Models from "../../../Models";
import FileUpload, { DocumentsCardReadySend } from "./";
import filterItemsStore from "../../../Store/filterItems";
import { getActiveDetailDocuments } from "../../../Helpers/documents";
import { useSendFileToDetailMutation } from "../../../Api/azure";
import { toast } from "react-toastify";

interface DocumentUploadProps {
    isUploading: boolean;
    isRemoving: boolean;
    match: Models.Match;
    filesReadySendState: Models.DocumentLinkUpload[];
    addFileToReadySendState: (documentFile: Models.DocumentLinkUpload) => any;
    updateFileToReadySendState: (
        documentFile: Models.DocumentLinkUpload
    ) => any;
    removeFileFromReadySendState: (fileName: string) => any;
}

export default function DocumentsCardFileUpload(props: DocumentUploadProps) {
    const { getActiveDetail, replaceDetails, updateDocumentAttributeGroup } =
        filterItemsStore();
    const activeDetail = getActiveDetail(props.match.params);
    const existingFileList: Models.DocumentLink[] =
        getActiveDetailDocuments(activeDetail);
    const {
        filesReadySendState,
        addFileToReadySendState,
        updateFileToReadySendState,
        removeFileFromReadySendState,
        isRemoving,
    } = props;

    const sendFileToDetail = useSendFileToDetailMutation();

    function filesToConfirm() {
        return filesReadySendState.filter(
            (f) => f.metaData.hostId === props.match.params.parameter
        );
    }

    function onConfirmDocumentUpload(
        acceptedFiles: File[],
        rejectedFiles: File[]
    ): void {
        if (acceptedFiles.length > 0) {
            const activeSiteDetail: Models.SiteDetail =
                activeDetail.detail as Models.SiteDetail;
            _.forEach(acceptedFiles, (file: File) => {
                var addFile: boolean = true;

                if (
                    _.find(
                        existingFileList,
                        (existingFile: Models.DocumentLink) =>
                            file.name.toLowerCase() ===
                            existingFile.fileName.toLowerCase()
                    )
                ) {
                    addFile = confirm(
                        `Do you want to overwrite the file '${file.name}'?`
                    );
                }

                if (addFile) {
                    const document: Models.DocumentLinkUpload =
                        fileToDocumentLinkUpload(activeSiteDetail, file);
                    addFileToReadySendState(document);
                }
            });
        } else if (rejectedFiles.length > 0) {
            toast.error(
                `File format is not supported. Supported: ${Constants.acceptedFileFormatsSimple}`
            );
        }
    }

    function sendFileToDetailHandler(document: Models.DocumentLinkUpload) {
        const fileName: string = `${document.fileName}.${document.filetype}`;
        const formData: FormData = new FormData();
        formData.append("files", document.file);
        formData.append("fileName", fileName);
        formData.append("documentType", document.metaData.documentType);
        formData.append("hostId", document.metaData.hostId);
        formData.append("siteName", document.metaData.siteName);
        formData.append(
            "functionalLocation",
            document.metaData.functionalLocation
        );
        // react-query mutation for upload api
        sendFileToDetail.mutate(
            {
                documentTarget: document.target,
                formData,
            },
            {
                onSuccess: (result: Models.DetailCollection) => {
                    removeFileFromReadySendState(fileName);
                    if (result.sites !== undefined) {
                        result.sites.forEach((site) => {
                            replaceDetails(site);
                            const dataGroup: Models.DataGroup = _.find(
                                site.dataGroups,
                                (dataGroup: Models.DataGroup) =>
                                    dataGroup.name.toLocaleLowerCase() ===
                                    "documents"
                            );
                            if (dataGroup) {
                                dataGroup.attributeGroups[0].siteId = site.id;
                                updateDocumentAttributeGroup([
                                    dataGroup.attributeGroups[0],
                                ]);
                            }
                        });
                    }
                },
                onError: () => {
                    toast.error("Could not upload the file(s)");
                },
            }
        );
    }

    return (
        <div className="DocumentsCardFileUpload">
            <FileUpload
                multiple={true}
                isUploading={sendFileToDetail.isPending}
                isRemoving={isRemoving}
                onDrop={(acceptedFiles: File[], rejectedFiles: File[]) =>
                    onConfirmDocumentUpload(acceptedFiles, rejectedFiles)
                }
            />
            {_.map(
                filesToConfirm(),
                (link: Models.DocumentLinkUpload, i: number) => (
                    <DocumentsCardReadySend
                        isUploading={sendFileToDetail.isPending}
                        key={i.toString()}
                        detail={activeDetail.detail as Models.SiteDetail}
                        document={link}
                        removeLinkDocumentFromReadySendState={
                            removeFileFromReadySendState
                        }
                        updateFileToReadySendState={updateFileToReadySendState}
                        uploadLinkDocument={sendFileToDetailHandler}
                    />
                )
            )}
        </div>
    );
}
